import React, { useEffect, useRef } from 'react'

interface OutsideClosableProps {
  isOpen: boolean
  onClose: () => void
  children: React.ReactNode
}

const OutsideClosable: React.FC<OutsideClosableProps> = ({ isOpen, onClose, children }) => {
  const wrapperRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    function handleClickOutside(event: MouseEvent) {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target as Node)) {
        onClose()
      }
    }

    if (isOpen) {
      document.addEventListener('mousedown', handleClickOutside)
    } else {
      document.removeEventListener('mousedown', handleClickOutside)
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [isOpen, onClose])

  if (!isOpen) return null

  return <div ref={wrapperRef}>{children}</div>
}

export default OutsideClosable
